// Announcement bar scrolling height & Header height

const announcementBar = document.querySelector(".announcement-bar-section");

function updateVisibleHeight() {
  if (!announcementBar) return; // Safety: don't crash if bar doesn't exist
  const rect = announcementBar.getBoundingClientRect();
  const visible = Math.max(
    0,
    Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0)
  );
  document.documentElement.style.setProperty('--announcement-visible-height', Math.round(visible) + "px");
}

window.addEventListener("scroll", updateVisibleHeight);
window.addEventListener("resize", updateVisibleHeight);
updateVisibleHeight();

document.documentElement.style.setProperty('--window-scroll-height', window.scrollY + "px");
window.addEventListener("scroll", () => {
  document.documentElement.style.setProperty('--window-scroll-height', window.scrollY + "px");
});
window.addEventListener('load', () => {

  const header_heigt = document.querySelector(".section-header");
  if (header_heigt) {
    const headerHeight = Math.round(header_heigt.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--header-height',`${headerHeight}px`);
  }
});

class CollectionCarousel extends HTMLElement {
  constructor() {
    super();
			
			var swiper = new Swiper(".js-collection-carousel", {
				slidesPerView: 2.0114,
				spaceBetween:10,
				slidesOffsetAfter:20,
        a11y: true,
				breakpoints: {
					769: {
						slidesPerView: 3.5,
						spaceBetween:  20,
						slidesOffsetAfter: 0,
					},
					1024: {
						slidesPerView: 4,
            spaceBetween:  20,
            slidesOffsetAfter: 40,
					},
          1400: {
						slidesPerView: 4.1126,
            spaceBetween:  20,
            slidesOffsetAfter: 0,
					}
				}
			});

  }
}

customElements.define('collection-carousel', CollectionCarousel);


class CollectionProductCarousel extends HTMLElement {
  connectedCallback() {
    if (this.swiper) return;

    const autoplayEnabled = this.dataset.autoplay === "true";
    const autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 100) || 3000;

    const swiperEl = this.querySelector(".js-collection-product-carousel");
    if (!swiperEl) return;

    const swiperConfig = {
		slidesPerView: 2.16,
				spaceBetween:16,
				slidesOffsetAfter:0,
        a11y: true,
        loop: true,
				breakpoints: {
					769: {
						slidesPerView:  2.5,
						spaceBetween:  16,
						slidesOffsetAfter: 40,
					},
					1024: {
						slidesPerView: 3.2265,
						spaceBetween:20,
						slidesOffsetAfter:40,
					},
          1450: {
						slidesPerView: 5.00,
						spaceBetween:20,
						slidesOffsetAfter:40,
					}
				}
    };

    if (autoplayEnabled) {
      swiperConfig.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    this.swiper = new Swiper(swiperEl, swiperConfig);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}


customElements.define('collection-product-carousel', CollectionProductCarousel);

class CustomerStories extends HTMLElement {
  constructor() {
    super();
			
			var swiper = new Swiper(".js-customer-stories", {
				slidesPerView: 1.0461,
				spaceBetween:10,
				slidesOffsetAfter:30,
        a11y: true,
				breakpoints: {
					769: {
						slidesPerView: 2.5,
						spaceBetween:  20,
						slidesOffsetAfter: 40,
					},
					1024: {
						slidesPerView: 3.7866,
						spaceBetween: 20,
						slidesOffsetAfter:40,
					},
				}
			});

  }
}

customElements.define('customer-stories', CustomerStories);

class CollectionGallery extends HTMLElement {
  constructor() {
    super();
			
			var swiper = new Swiper(".js-collection-gallery", {
				slidesPerView: 2.2419,
				spaceBetween:5,
				slidesOffsetAfter:10,
        a11y: true,
				breakpoints: {
					769: {
						slidesPerView: 2.5,
						spaceBetween:  10,
						slidesOffsetAfter: 30,
					},
					1024: {
						slidesPerView: 4.176,
						spaceBetween: 20,
						slidesOffsetAfter:40,
					}
				}
			});

  }
}

customElements.define('collection-gallery', CollectionGallery);

class LoadMore extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('#load-more-btn');
    this.gridId = this.dataset.grid;
    this.grid = document.getElementById(this.gridId);

    this.currentPage = Number(this.dataset.currentPage);
    this.productsPerPage = Number(this.dataset.productsPerPage);
    this.totalItems = Number(this.dataset.totalItems);
    
    // Calculate total pages
    this.totalPages = Math.ceil(this.totalItems / this.productsPerPage);

    if (this.button && this.grid) {
      this.button.addEventListener('click', () => this.loadMore());
    }
  }

  loadMore() {
    if (this.currentPage >= this.totalPages) return;

    const nextPage = this.currentPage + 1;
    const params = new URLSearchParams(window.location.search);
    params.set('page', nextPage);

    const url = `${window.location.pathname}?${params.toString()}`;

    this.setLoading(true);

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll(`#${this.gridId} > li`);

        if (!newItems.length) {
          this.remove();
          return;
        }

        newItems.forEach(item => this.grid.appendChild(item));

        this.currentPage = nextPage;
        this.dataset.currentPage = nextPage;

        if (this.currentPage >= this.totalPages) {
          this.remove();
        } else {
          this.setLoading(false);
        }
      })
      .catch(err => {
        console.error('Load more failed', err);
        this.setLoading(false);
      });
  }

  setLoading(isLoading) {
    this.button.disabled = isLoading;
    this.button.textContent = isLoading ? 'Loading…' : 'View More';
  }
}

customElements.define('load-more-products', LoadMore);

class ActiveFilterCount extends HTMLElement {
  constructor() {
    super();

    this.countElement = this.querySelector(
      "[data-filter-count]"
    );
  }

  connectedCallback() {
    this.update();

    window.addEventListener(
      "popstate",
      this.update.bind(this)
    );

    const originalPushState = history.pushState;
    history.pushState = (...args) => {
      originalPushState.apply(history, args);
      this.update();
    };

    const originalReplaceState = history.replaceState;
    history.replaceState = (...args) => {
      originalReplaceState.apply(history, args);
      this.update();
    };

    document.addEventListener(
      "click",
      this.handleFilterClick.bind(this)
    );
  }

  handleFilterClick() {
    setTimeout(() => {
      this.update();
    }, 500);
  }

  update() {
    if (!this.countElement) return;

    const params = new URLSearchParams(
      window.location.search
    );

    const activeFilters = new Set();

    params.forEach((value, key) => {
      if (!key.startsWith("filter.")) return;

      if (key.includes(".price.")) {
        activeFilters.add("price");
      } else {
        activeFilters.add(key);
      }
    });

    const count = activeFilters.size;

    this.countElement.textContent = count;

    this.classList.toggle(
      "hidden",
      count === 0
    );
  }
}

if (!customElements.get("active-filter-count")) {
  customElements.define("active-filter-count", ActiveFilterCount);
}


class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.currentProductHandle = this.dataset.productId;

    this.trackCurrentProduct();
    this.renderProducts();
  }

  trackCurrentProduct() {
    if (!this.currentProductHandle) return;

    let viewedProducts =
      JSON.parse(localStorage.getItem('recently_viewed_products')) || [];
    viewedProducts = viewedProducts.filter(
      handle => handle !== this.currentProductHandle
    );
    viewedProducts.unshift(this.currentProductHandle);
    viewedProducts = viewedProducts.slice(0, 12);

    localStorage.setItem(
      'recently_viewed_products',
      JSON.stringify(viewedProducts)
    );
  }

  getViewedProducts() {
    try {
      return (
        JSON.parse(
          localStorage.getItem('recently_viewed_products')
        ) || []
      );
    } catch (e) {
      return [];
    }
  }

  async renderProducts() {
    const viewedProducts = this.getViewedProducts().filter(
      handle => handle !== this.currentProductHandle
    );

    if (!viewedProducts.length) {
      this.style.display = 'none';
      return;
    }

    const wrapper = this.querySelector(
      '#recently-viewed-wrapper'
    );

    if (!wrapper) return;
    const cards = await Promise.all(
      viewedProducts.map(handle =>
        this.fetchProductCard(handle)
      )
    );

    const validCards = cards.filter(Boolean);

    if (!validCards.length) {
      this.style.display = 'none';
      return;
    }
    wrapper.innerHTML = validCards
      .map(
        card => `
          <div class="swiper-slide main-product">
            ${card}
          </div>
        `
      )
      .join('');
    document.dispatchEvent(
      new CustomEvent('recentlyViewedLoaded')
    );
  }

  async fetchProductCard(handle) {
    try {
      const response = await fetch(
        `/products/${handle}?view=card`
      );

      if (!response.ok) return null;

      return await response.text();
    } catch (error) {
      console.error(
        'Recently viewed fetch error:',
        error
      );

      return null;
    }
  }
}

if (!customElements.get('recently-viewd-products')) {
  customElements.define('recently-viewd-products', RecentlyViewedProducts);
}

class AttachmentField extends HTMLElement {
  connectedCallback() {
  this.inputField = this.querySelector("input");
  this.placeholder = this.querySelector(".attachment-place-holder-text");
  this.uploadButton = this.querySelector(".upload-button");
  this.cancelButton = this.querySelector(".cancle-button");

  this.uploadButton.addEventListener("click", () => this.inputField.click());

  this.inputField.addEventListener("change", () => {
    const file = this.inputField.files[0];
    if (file) {
      this.placeholder.textContent = file.name;
      this.cancelButton.classList.remove("hidden");
      this.uploadButton.classList.add("hidden");
    }
  });

  this.cancelButton.addEventListener("click", () => {
    this.inputField.value = "";
    this.placeholder.textContent = "Attachments *";
    this.cancelButton.classList.add("hidden");
    this.uploadButton.classList.remove("hidden");
  });
}
}

customElements.define('attachment-field', AttachmentField);


class AnimateAccordion extends HTMLElement {
  constructor() {
    super();
    this.details  = this.querySelector('details');
    this.summary  = this.querySelector('summary');
    this.content  = this.querySelector('.details-content');
    this.isAnimating = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    if (this.isAnimating) return;

    if (this.details.open) {
      this.shrink();
    } else {
      this.closeOthers();
      this.open();
    }
  }

  closeOthers() {
    document.querySelectorAll('acordion-animated').forEach(acc => {
      if (acc !== this && acc.details.open && !acc.isAnimating) {
        acc.shrink();
      }
    });
  }

  shrink() {
    this.isAnimating = true;

    // Lock current height explicitly
    this.content.style.height = this.content.scrollHeight + 'px';
    this.content.style.overflow = 'hidden';
    this.content.style.transition = 'height 350ms ease';

    // Force reflow so browser registers the starting height
    this.content.offsetHeight;

    // Now animate to 0
    this.content.style.height = '0px';

    this.content.addEventListener('transitionend', () => {
      this.details.open = false;
      this.content.style.height = '';
      this.content.style.overflow = '';
      this.content.style.transition = '';
      this.isAnimating = false;
    }, { once: true });
  }

  open() {
    this.isAnimating = true;
    this.details.open = true;

    // Measure target height
    this.content.style.height = '0px';
    this.content.style.overflow = 'hidden';
    this.content.style.transition = 'none';

    // Force reflow
    this.content.offsetHeight;

    const targetHeight = this.content.scrollHeight + 'px';

    this.content.style.transition = 'height 350ms ease';
    this.content.style.height = targetHeight;

    this.content.addEventListener('transitionend', () => {
      this.content.style.height = '';
      this.content.style.overflow = '';
      this.content.style.transition = '';
      this.isAnimating = false;
    }, { once: true });
  }
}

customElements.define('acordion-animated', AnimateAccordion);


document.querySelectorAll(".desk-scroll-wrapper").forEach((slider) => {
  let isDown = false;
  let startPos;
  let scrollStart;

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    slider.classList.add("active");

    if (window.innerWidth >= 990) {
      startPos = e.pageY;
      scrollStart = slider.scrollTop;
    } else {
      startPos = e.pageX;
      scrollStart = slider.scrollLeft;
    }
  });

  ["mouseleave", "mouseup"].forEach((event) => {
    slider.addEventListener(event, () => {
      isDown = false;
      slider.classList.remove("active");
    });
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;

    e.preventDefault();

    if (window.innerWidth >= 990) {
      const walk = (e.pageY - startPos) * 2;
      slider.scrollTop = scrollStart - walk;
    } else {
      const walk = (e.pageX - startPos) * 2;
      slider.scrollLeft = scrollStart - walk;
    }
  });
});



class HeroCarousel extends HTMLElement {
  connectedCallback() {
    if (this.swiper) return;

    const autoplayEnabled = this.dataset.autoplay === "true";
    const autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 100) || 3000;

    const swiperEl = this.querySelector(".js-hero-carousel");
    if (!swiperEl) return;

    const swiperConfig = {
		slidesPerView: 1,
				spaceBetween:10,
        a11y: true,
        loop: true,
				breakpoints: {
					769: {
						slidesPerView:  1,
						spaceBetween:  10,
					},
					1024: {
						slidesPerView: 1,
						spaceBetween:20,
					},
          1450: {
						slidesPerView: 1,
						spaceBetween:20,
					}
				},
        pagination: {
          el: ".hero-carousel-pagiination",
           clickable: true,
        },
    };

    if (autoplayEnabled) {
      swiperConfig.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    this.swiper = new Swiper(swiperEl, swiperConfig);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}


customElements.define('hero-carousel', HeroCarousel);